import CoreComponent from '../../core/CoreComponent.vue';
import Swiper, { Pagination, Navigation, Keyboard, Thumbs, EffectFade } from 'swiper';
import 'swiper/css';
export default {
  extends: CoreComponent,
  data: () => {
    return {
      isMobile: null,
      micrositeNavTrigger: null,
      openIcon: null,
      closeIcon: null
    };
  },
  mounted() {
    // Add microsite header class if XF contains header in microsite variant
    const headerXF = document.querySelector('.experiencefragment.main-header');
    if (headerXF && headerXF.querySelector('.microsite-light')) {
      headerXF.classList.add('microsite-header-XF');
    }

    // Hide the mobile header container initially
    this.rearrangeHeaderElements();
    window.addEventListener('resize', this.rearrangeHeaderElements);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.rearrangeHeaderElements);
  },
  methods: {
    rearrangeHeaderElements() {
      const swiperWrapper = document.querySelector('.swiper-wrapper');
      const mobileHeaderContainer = document.querySelector('.mobile-header-container');
      const desktopHeaderContainer = document.querySelector('.main-header-slider');
      const headerContainer = document.querySelector('.cmp--header_container');
      const header = document.querySelector('.cmp-main-header');
      const languageSelector = document.querySelector('.cmp--header_language-modal-wrapper');
      this.micrositeNavTrigger = document.querySelector('.microsite-nav-trigger');
      if (this.micrositeNavTrigger) {
        this.openIcon = this.micrositeNavTrigger.querySelector(".container-hamburger-open");
        this.closeIcon = this.micrositeNavTrigger.querySelector(".container-hamburger-close");
        this.micrositeNavTrigger.addEventListener('click', this.onMicrositeNavTriggerClick);
      }
      const wrapper = document.querySelector('.dropdown-toggle-wrapper');
      const dropdowns = document.querySelectorAll('.dropdown-box');
      if (window.innerWidth <= 768) {
        this.isMobile = true;
        mobileHeaderContainer.appendChild(swiperWrapper);
        header.classList.add('mobile');
        desktopHeaderContainer.style.display = 'none';
        swiperWrapper.style.transform = 'none';
        const offset = headerContainer.getBoundingClientRect().height + header.getBoundingClientRect().height;
        mobileHeaderContainer.style.top = offset + 'px';
        languageSelector.style.top = offset + 'px';
        dropdowns.forEach(box => {
          box.style.top = 0 + 'px';
        });
      } else {
        this.isMobile = false;
        desktopHeaderContainer.appendChild(swiperWrapper);
        header.classList.remove('mobile');
        desktopHeaderContainer.style.display = 'block';
        mobileHeaderContainer.style.display = 'none';
        const headerRect = header.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const offset = wrapperRect.height + (headerRect.height - wrapperRect.height) / 2;
        languageSelector.style.top = headerRect.bottom + 'px';
        dropdowns.forEach(box => {
          box.style.top = offset + 'px';
        });
      }
      this.closeMicrositeNav();
    },
    onMicrositeNavTriggerClick() {
      if (!this.isMobile) return;
      let mobileHeaderContainer = document.querySelector('.mobile-header-container');
      if (mobileHeaderContainer.style.display === 'none' || mobileHeaderContainer.style.display === '') {
        mobileHeaderContainer.style.display = 'block';
      } else {
        mobileHeaderContainer.style.display = 'none';
      }
      if (this.openIcon.style.display === 'none') {
        this.openIcon.style.display = 'block';
        this.closeIcon.style.display = 'none';
      } else {
        this.openIcon.style.display = 'none';
        this.closeIcon.style.display = 'block';
      }
    },
    closeMicrositeNav() {
      if (!this.isMobile) return;
      let mobileHeaderContainer = document.querySelector('.mobile-header-container');
      mobileHeaderContainer.style.display = 'none';
      this.openIcon.style.display = 'block';
      this.closeIcon.style.display = 'none';
    }
  }
};